import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    switch: {
      '&.MuiFormControlLabel-root': {
        margin: '0px !important',
      },
      '& .MuiFormControlLabel-label': {
        marginLeft: '8px',
      },
      '& .MuiSwitch-root': {
        width: 39,
        height: 24,
        padding: 0,
        borderRadius: 12,
      },
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 3,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(15px)',
          color: STYLE.COLOR.WHITE,
          '& + .MuiSwitch-track': {
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color: STYLE.COLOR.WHITE,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-disabled': {
        cursor: 'not-allowed !important',
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 18,
        height: 18,
        boxShadow: 'none',
      },
      '& .MuiSwitch-track': {
        borderRadius: 12,
        backgroundColor: STYLE.COLOR.TABS_BORDER,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
      },
    },
  }),
);
